import React, { useEffect, useState } from "react";
import { UseApi } from "../../../../hooks/use-api";
import { GetBrand, UpdateBrand } from "../../../../Services/lib/brand";
import TextInput from "../../../../components/TextInput";
import Loader from "../../../../components/Loader";

const GoogleAnalytic = ({ setValue, value, busy }) => {
	return (
		<>
			{busy ? (
				<Loader />
			) : (
				<>
					<p>
						{/* className={styles.space10} */}
						Copy your{" "}
						<a
							href="https://analytics.google.com/analytics/web/"
							target="_blank"
						>
							Google Analytics ID
						</a>{" "}
						and paste it here. Find out how to
						<a
							href="https://support.google.com/analytics/answer/9304153#zippy=%2Cadd-the-tag-to-a-website-builder-or-cms-hosted-website-eg-wordpress-shopify-etc"
							target="_blank"
						>
							{" "}
							get your Google Analytics ID.
						</a>
					</p>
					<TextInput
						placeholder=""
						label={"  "}
						onChangeInput={setValue}
						defaultValue={value}
					/>
				</>
			)}
		</>
	);
};

export default GoogleAnalytic;
